// This file handles SVG icon loading and management

import Vue from 'vue'
import SvgIcon from '@/components/svgIcon'

// Register SvgIcon as a global component
Vue.component('SvgIcon', SvgIcon)

// Create a cache for loaded SVG icons
const svgCache = new Map()

/**
 * Add global styles to ensure SVG icons are properly displayed
 */
function ensureSvgStyles() {
  // Only add styles once
  if (document.getElementById('svg-icon-global-styles')) {
    return
  }

  const style = document.createElement('style')
  style.id = 'svg-icon-global-styles'
  style.innerHTML = `
    .svg-icon {
      width: 1em;
      height: 1em;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
    }
    .svg-external-icon {
      background-color: currentColor;
      mask-size: cover !important;
      display: inline-block;
    }`
  document.head.appendChild(style)
}

// Ensure global styles are applied
if (typeof window !== 'undefined') {
  // Only run in browser environment
  ensureSvgStyles()
}

/**
 * Load an SVG icon dynamically
 * @param {String} iconName - The name of the icon without extension
 * @returns {Promise} - A promise that resolves when the icon is loaded
 */
export const loadSvgIcon = (iconName) => {
  if (svgCache.has(iconName)) {
    return Promise.resolve(svgCache.get(iconName))
  }

  svgCache.set(iconName, 'loading')

  return import(/* webpackChunkName: "svg-[request]" */ `@/icons/svg/${iconName}.svg`)
    .then((module) => {
      svgCache.set(iconName, module)
      return module
    })
    .catch((error) => {
      console.error(`Failed to load SVG icon: ${iconName}`, error)
    })
}

// Preload some commonly used icons
const commonIcons = [
  'dark',
  'contact-us',
  'icon-crm-earth',
  'icon-crm-mail-outlined',
  'sy',
  'zjgl'
  // Add other commonly used icons here
]

// Preload common icons to avoid unnecessary delay for frequently used icons
commonIcons.forEach((icon) => {
  loadSvgIcon(icon).catch(() => {
    // Silent catch for preloaded icons
  })
})

// Export the SVG cache
export { svgCache }
